import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  HostListener,
} from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Subject, Observable, BehaviorSubject } from "rxjs";
import * as _ from "underscore";
import { RootStoreState } from "src/app/root-store";
import { takeUntil } from "rxjs/operators";
import { ColumnConfigItem } from "src/app/models/ColumnConfigItem";

import {
  createPurchaseQuoteError,
  createPurchaseQuoteLoading,
  createRentalQuoteError,
  createRentalQuoteLoading,
  getCreatedPurchaseQuote,
  getCreatedRentalQuote,
  getQuote,
  getQuoteError,
  getQuoteList,
  getQuoteListError,
  getQuoteListLoading,
  getQuoteListRes,
  getQuoteLoading,
  updateQuoteError,
  updateQuoteLoading,
  updateQuoteSuccess,
} from "src/app/root-store/kwikspace-app-store/selectors/quote.selector";
import { getCurrentUser } from "src/app/root-store/main-app-store/selectors/auth.selector";
import { Quote } from "src/app/models/Quote.model";
import {
  ClearQuoteList,
  CreatePurchaseQuote,
  CreateRentalQuote,
  GetCustomerQuoteList,
  GetQuote,
  GetQuoteList,
  GetSalesQuoteList,
  UpdateQuote,
} from "src/app/root-store/kwikspace-app-store/actions/quote.action";
import { User } from "src/app/models/user";
import { AppRoutes } from "src/app/shared/endpoints.enum";
import { Router } from "@angular/router";
import { PaginationService } from "src/app/services/pagination.service";
import { ModalComponent } from "src/app/core/components/modal/modal.component";
import { TanToastrService } from "src/app/services/toastr.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { StaticDataService } from "src/app/services/static-data.service";
import {
  GetBuildings,
  GetOrganizations,
  GetSalesReps,
} from "src/app/root-store/kwikspace-app-store/actions/kwikspace.action";
import {
  getBuildings,
  getBuildingsError,
  getBuildingsLoading,
  getOrganizations,
  getOrganizationsError,
  getOrganizationsLoading,
  getSalesReps,
  getSalesRepsError,
  getSalesRepsLoading,
} from "src/app/root-store/kwikspace-app-store/selectors/kwikspace.selector";
import {
  getCreatedProductConfiguration,
  getCreatedProductConfigurationError,
  getCreatedProductConfigurationLoading,
} from "src/app/root-store/kwikspace-app-store/selectors/product.selector";
import {
  ClearProductConfiguration,
  CreateProductConfiguration,
} from "src/app/root-store/kwikspace-app-store/actions/product.action";
import {
  ClearRentalLineItems,
  CreateRentalLineItem,
} from "src/app/root-store/kwikspace-app-store/actions/rental.action";
import {
  getCreatedLineItems,
  getCreatedLineItemsError,
  getCreatedLineItemsLoading,
} from "src/app/root-store/kwikspace-app-store/selectors/rental.selector";
import { ClearPurchaseLineItem, ClearPurchaseList, CreatePurchaseLineItem, CreatePurchaseLineItemConfig } from "src/app/root-store/kwikspace-app-store/actions/purchase.action";
import { getCreatedLineItemConfigs, getCreatedPurchaseLineItems, getCreatedPurchaseLineItemsError, getCreatedPurchaseLineItemsLoading } from "src/app/root-store/kwikspace-app-store/selectors/purchase.selector";

@Component({
  selector: "kwikspace-quotes",
  templateUrl: "./quotes.component.html",
  styleUrls: ["./quotes.component.scss"],
})
export class QuotesComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject();

  @ViewChild("editCustomerQuoteModal", { static: false })
  editCustomerQuoteModal: ModalComponent;

  @ViewChild("editQuoteModal", { static: false })
  editQuoteModal: ModalComponent;

  @ViewChild("editQuoteDismissModal", { static: false })
  editQuoteDismissModal: ModalComponent;

  @ViewChild("noViewModal", { static: false })
  noViewModal: ModalComponent;

  @ViewChild("duplicateModal", { static: false })
  duplicateModal: ModalComponent;

  user: User;

  quoteLoading$: Observable<any> = this.store.select(getQuoteLoading);
  quoteError$: Observable<any> = this.store.select(getQuoteError);

  quotesLoading$: Observable<any> = this.store.select(getQuoteListLoading);
  quotesError$: Observable<any> = this.store.select(getQuoteListError);

  updateQuoteLoading$: Observable<any> = this.store.select(updateQuoteLoading);
  updateQuoteError$: Observable<any> = this.store.select(updateQuoteError);

  salesRepsLoading$: Observable<any> = this.store.select(getSalesRepsLoading);
  salesRepsError$: Observable<any> = this.store.select(getSalesRepsError);

  buildingsLoading$: Observable<any> = this.store.select(getBuildingsLoading);
  buildingsError$: Observable<any> = this.store.select(getBuildingsError);

  organizationsLoading$: Observable<any> = this.store.select(
    getOrganizationsLoading
  );
  organizationsError$: Observable<any> = this.store.select(
    getOrganizationsError
  );

  newRentalQuoteLoading$: Observable<any> = this.store.select(
    createRentalQuoteLoading
  );
  newRentalQuoteError$: Observable<any> = this.store.select(
    createRentalQuoteError
  );
  
  newPurchaseQuoteLoading$: Observable<any> = this.store.select(
    createPurchaseQuoteLoading
  );
  newPurchaseQuoteError$: Observable<any> = this.store.select(
    createPurchaseQuoteError
  );

  createLineItemLoading$: Observable<any> = this.store.select(
    getCreatedLineItemsLoading
  );
  createLineItemError$: Observable<any> = this.store.select(
    getCreatedLineItemsError
  );
  
  createPurchaseLineItemLoading$: Observable<any> = this.store.select(
    getCreatedPurchaseLineItemsLoading
  );
  createPurchaseLineItemError$: Observable<any> = this.store.select(
    getCreatedPurchaseLineItemsError
  );

  createProductConfigurationLoading$: Observable<any> = this.store.select(
    getCreatedProductConfigurationLoading
  );
  createProductConfigurationError$: Observable<any> = this.store.select(
    getCreatedProductConfigurationError
  );
  
  // createProductConfigurationLoading$: Observable<any> = this.store.select(
  //   getCreatedProductConfigurationLoading
  // );
  // createProductConfigurationError$: Observable<any> = this.store.select(
  //   getCreatedProductConfigurationError
  // );

  editQuoteForm: FormGroup;

  quotes: Quote[];
  rawQuoteList: Quote[];
  pageCount = 1;
  pageLinks;
  itemCount = 0;
  currentPage = 1;
  pageToLoad;

  isStaff: boolean = false;
  isCustomer: boolean = false;
  isAdmin: boolean = false;
  customerId: any = null;

  actionButtons: any[];
  iconClass: string;
  columnConfig: ColumnConfigItem[];
  filterDropdownOptions: any[];

  filterBy: any;
  sortBy: any;
  searchTerm: any;

  hasQuotes: boolean = false;
  canSearch: boolean = true;
  canEditStatus: boolean = true;
  selectedQuote: any = null;
  selectedQuoteStatus: any = null;
  selectedQuoteOwner: any = null;
  quoteStatusCustomer: any[] = [];
  quoteStatus: any[] = [];
  salesReps: any[] = [];
  buildingTypes: any[] = [];
  organizationalTypes: any[] = [];

  lineItems: any[] = [];
  productConfigurations: any[] = [];
  addedLineItems: any[] = [];

  hasActionColEdit: boolean = true;
  hasActionColDuplicate: boolean = false;

  openModal: any = null;

  quote: Quote = null;
  createdQuote: any = null;
  quoteNumber: any = null;

  isMobile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    window.innerWidth <= 768
  );
  purchaseAssetItemConfigurations: any;

  @HostListener("window:resize", ["$event"])
  setIsMobile(event) {
    const isMobile = event.target.innerWidth <= 768;
    this.isMobile.next(isMobile);
  }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private store: Store<RootStoreState.RootState>,
    private paginationService: PaginationService,
    private toastrService: TanToastrService,
    private staticDataService: StaticDataService
  ) { }

  ngOnInit() {
    this.quoteStatusCustomer = this.staticDataService.getQuoteStatusCustomer();
    this.quoteStatus = this.staticDataService.getQuoteStatus();

    this.store.dispatch(new GetBuildings());
    this.store.dispatch(new GetOrganizations());
    this.store.dispatch(new GetSalesReps());

    this.editQuoteForm = this.formBuilder.group({
      quote_status: [null, []],
      quote_owner: [null, []],
    });

    this.store
      .select(getBuildings)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((buildings: any) => {
        if (buildings) {
          this.buildingTypes = buildings;
        }
      });

    this.store
      .select(getOrganizations)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((organizations: any) => {
        if (organizations) {
          this.organizationalTypes = organizations;
        }
      });

    this.store
      .select(getSalesReps)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((reps: any) => {
        if (reps) {
          this.salesReps = reps;
        }
      });

    this.actionButtons = [
      {
        name: this.isMobile.value ? " Rental quote" : " Create a Rental quote",
        id: "addRental",
      },
      {
        name: this.isMobile.value
          ? " Purchase quote"
          : " Create a Purchase quote",
        id: "addPurchase",
      },
    ];

    this.iconClass = "fa fa-plus text-white";

    this.columnConfig = [
      {
        oldName: "marketSegment",
        isVisible: false,
      },
      {
        oldName: "quoteValidity",
        isVisible: false,
      },
      {
        oldName: "buildingSpecification",
        isVisible: false,
      },
      {
        oldName: "requiredBy",
        isVisible: false,
      },
      {
        oldName: "occupancy",
        isVisible: false,
      },
      {
        oldName: "shipping",
        isVisible: false,
      },
      {
        oldName: "shippingAddress1",
        isVisible: false,
      },
      {
        oldName: "shippingAddress2",
        isVisible: false,
      },
      {
        oldName: "shippingPostal",
        isVisible: false,
      },
      {
        oldName: "shippingProvince",
        isVisible: false,
      },
      {
        oldName: "shippingSuburb",
        isVisible: false,
      },
      {
        oldName: "shippingArea",
        isVisible: false,
      },
      {
        oldName: "quoteLocation",
        isVisible: false,
      },
      {
        oldName: "requiredDate",
        isVisible: false,
      },
      {
        oldName: "notes",
        isVisible: false,
      },
      {
        oldName: "lineItems",
        isVisible: false,
      },
      {
        oldName: "purchaseLineItems",
        isVisible: false,
      },
      {
        oldName: "rentalPeriod",
        isVisible: false,
      },
      {
        oldName: "assets",
        isVisible: false,
      },
      {
        oldName: "modifiedDate",
        isVisible: false,
      },
      {
        oldName: "building",
        isVisible: false,
      },
      {
        oldName: "quoteNumber",
        isSortable: true,
      },
      {
        oldName: "quoteType",
        isVisible: false,
      },
      {
        oldName: "ourReference",
        isVisible: false,
      },
      {
        oldName: "yourReference",
        isVisible: false,
      },
      {
        oldName: "siteAllocation",
        isVisible: false,
      },
      {
        oldName: "customerAccountNumber",
        isVisible: false,
      },
      {
        oldName: "quoteStatus",
        newName: "status",
        isSortable: true,
      },
    ];

    this.store
      .select(getCurrentUser)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.isAdmin = res.isStaff && res.isSuperuser;
          this.isCustomer = !res.isStaff && res.customer != null ? true : false;
          this.isStaff =
            res.isStaff && res.salesRep != null && res.customer == null
              ? true
              : false;

          this.user = res;

          if (!this.isCustomer && this.isStaff) {
            this.hasActionColDuplicate = true;
          }

          this.getQuotes();
        }
      });

    this.store
      .select(getQuoteList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((quotes: any) => {
        if (quotes) {
          let _quotes = quotes.results
            ? quotes.results
            : quotes.length > 0
              ? quotes
              : [];

          this.itemCount = quotes.count;
          this.pageLinks = quotes.links;
          this.pageCount =
            this.itemCount < 10 ? 1 : Math.ceil(this.itemCount / 10);

          if (_quotes.length > 0) {
            this.searchTerm = "";
            this.filterBy = "";
            this.sortBy = "";
          }

          this.buildQuotesTable(_quotes);
        }
      });
  }

  buildQuotesTable(quotes) {
    if (quotes.length > 0) {
      quotes.forEach((quote) => {
        Object.keys(quote).forEach((key) => {
          let obj = quote[key];
          if (obj) {
            if (key == "quoteOwner") {
              quote[key] = obj.user.firstName + " " + obj.user.lastName;
            }
            if (key == "organization") {
              quote[key] = obj.name;
            }
            if (key == "customer") {
              if (obj.company && obj.company.name) {
                quote[key] = obj.company.name;
              } else {
                quote[key] = "no customer";
              }
            }
            if (key == "createdDate") {
              quote[key] = new Date(obj).toLocaleDateString("en-US", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              });
            }
          }
        });
      });
    }

    this.canSearch = this.isCustomer ? false : true;

    this.getFilterOptions();

    this.quotes = quotes;
    this.hasQuotes = true;
  }

  getFilterOptions() {
    this.filterDropdownOptions = [
      {
        id: "clear",
        key: "Clear",
        filters: [
          {
            id: "clear",
            name: "Clear Filters",
          },
        ],
      },
      {
        id: "quote_type",
        key: "Type",
        filters: [
          {
            id: "rental",
            name: "Rental",
          },
          {
            id: "purchase",
            name: "Purchase",
          },
        ],
      },
      {
        id: "quote_status",
        key: "Status",
        filters: this.quoteStatus,
      },
      {
        id: "building",
        key: "Building",
        filters: this.buildingTypes,
      },
      {
        id: "organization",
        key: "Sector",
        filters: this.organizationalTypes,
      },
    ];
  }

  setQuoteStatus() {
    this.selectedQuoteStatus = this.editQuoteForm.value.quote_status;
  }

  setQuoteOwner() {
    this.selectedQuoteOwner = this.editQuoteForm.value.quote_owner;
  }

  getQuotes() {
    this._reloadList();
  }

  viewItem(quoteDetails: any) {
    if (this.isCustomer && !this.isStaff) {
      if (
        quoteDetails.quoteStatus == "new" ||
        quoteDetails.quoteStatus == "cancelled"
      ) {
        this.noViewModal.open();
      } else {
        const route =
          AppRoutes.PWA + AppRoutes.QUOTE_LIST + "/" + quoteDetails.id;
        this.router.navigate([route]);
      }
    } else {
      const route =
        AppRoutes.PWA + AppRoutes.QUOTE_LIST + "/" + quoteDetails.id;
      this.router.navigate([route]);
    }
  }

  editItem(quoteDetails: any) {
    this.selectedQuote = quoteDetails;
    this.editQuoteForm
      .get("quote_status")
      .setValue(this.selectedQuote.quoteStatus);

    if (this.isCustomer && !this.isStaff) {
      if (this.selectedQuote.quoteType == "rental") {
        this.canEditStatus =
          this.selectedQuote.quoteStatus == "approved" ? true : false;

        if (this.canEditStatus) {
          this.openModal = 1;
          this.editCustomerQuoteModal.open();
        } else if (this.selectedQuote.quoteStatus == "new") {
          const route = `${AppRoutes.PWA + "quotes/edit/rental/" + this.selectedQuote.id
            }`;
          this.router.navigate([route]);
        } else {
          this.editQuoteDismissModal.open();
        }
      } else if (this.selectedQuote.quoteType == "purchase") {
        this.canEditStatus =
          this.selectedQuote.quoteStatus == "approved" ? true : false;

        if (this.canEditStatus) {
          this.openModal = 1;
          this.editCustomerQuoteModal.open();
        } else if (this.selectedQuote.quoteStatus == "new") {
          const route = `${AppRoutes.PWA + "quotes/edit/purchase/" + this.selectedQuote.id
            }`;
          this.router.navigate([route]);
        } else {
          this.editQuoteDismissModal.open();
        }
      }
    }

    if (!this.isCustomer && (this.isStaff || this.isAdmin)) {
      this.canEditStatus =
        this.selectedQuote.quoteStatus == "new" ||
          this.selectedQuote.quoteStatus == "approved"
          ? false
          : true;

      if (this.selectedQuote.quoteType == "rental") {
        if (!this.canEditStatus) {
          const route = `${AppRoutes.PWA + "quotes/edit/rental/" + this.selectedQuote.id
            }`;
          this.router.navigate([route]);
        } else if (this.canEditStatus) {
          this.openModal = 2;
          this.editQuoteModal.open();
        } else {
          this.editQuoteDismissModal.open();
        }
      } else if (this.selectedQuote.quoteType == "purchase") {
        if (!this.canEditStatus) {
          const route = `${AppRoutes.PWA + "quotes/edit/purchase/" + this.selectedQuote.id
            }`;
          this.router.navigate([route]);
        } else if (this.canEditStatus) {
          this.openModal = 2;
          this.editQuoteModal.open();
        } else {
          this.editQuoteDismissModal.open();
        }
      }
    }
  }

  duplicateItem(quoteDetails: any) {
    this.store.dispatch(new ClearQuoteList());
    this.store.dispatch(new ClearRentalLineItems());
    this.store.dispatch(new ClearProductConfiguration());
    this.store.dispatch(new ClearPurchaseLineItem());
    this.store.dispatch(new ClearPurchaseList());


    this.duplicateModal.open();

    this.store
      .select(getQuote)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((quote) => {
        if (quote) {
          this.quote = quote;
          this.duplicateQuote();
        }
      });

    this.store.dispatch(new GetQuote(quoteDetails.id));
  }

  duplicateQuote() {
    if (this.quote.quoteType == "rental") {
      if (this.quote.lineItems.length > 0) {
        this.quote.lineItems.forEach((item, index) => {
          const lineItem = {
            name: item.name,
            rental_option: item.rentalOption.id,
            rental_period: item.rentalPeriod,
            quantity: item.quantity,
            product_configurations: [],
            delivery_charge: item.deliveryCharge.id,
            idx: index,
          };

          this.lineItems.push(lineItem);

          if (item.productConfigurations.length > 0) {
            item.productConfigurations.forEach((product, index) => {
              const productItem = {
                name: "," + lineItem.name + "," + (index + 1),
                quantity: product.quantity,
                product: product.product.id,
                idx: index,
              };

              this.productConfigurations.push(productItem);
            });
          }
        });

        this.saveDuplicateRentalQuote();
      }
    } else if (this.quote.quoteType == "purchase") {
      this.quote.purchaseLineItems.forEach((item, index) => {
        const lineItem = {
          // name: item.name,
          // rental_option: item.rentalOption.id,
          // rental_period: item.rentalPeriod,
          // quantity: item.quantity,
          // product_configurations: [],
          // delivery_charge: item.deliveryCharge.id,
          idx: index,
          deliveryCharge: item.deliveryCharge?.id,
          deliveryChargeExtra: item.deliveryChargeExtra?.id,
          deliveryChargeExtraQty: item.deliveryChargeExtraQty ? item.deliveryChargeExtraQty : 0,
          deliveryChargeOptional: item.deliveryChargeOptional ? item.deliveryChargeOptional?.id : '',
          deliveryChargeQty: item.deliveryChargeQty ? item.deliveryChargeQty : 0,
          deliveryChargeVariation: item.deliveryChargeVariation,
          description: item.description,
          drawingNo: item.drawingNo,
          floorPlannerSku: item.floorPlannerSku,
          id: item.id,
          name: item.name,
          purchaseAssetItemConfigurations: [],
          quantity: item.quantity,
          template: item.template,
          thumbnail: item.thumbnail,
          thumbnailThreeD: item.thumbnailThreeD,
          totalPrice: item.totalPrice,
          unit: item.unit,
          unitPrice: item.unitPrice,
          unitSize: item.unitSize
        };

        this.lineItems.push(lineItem);

        if (item.purchaseAssetItemConfigurations.length > 0) {
          item.purchaseAssetItemConfigurations.forEach((product, index) => {
            const productItem = {
              // name: "," + lineItem.name + "," + (index + 1),
              // quantity: product.quantity,
              // product: product.product.id,
              idx: index,
              addedName: product.addedName,
              asset: product.asset,
              id: product.id,
              name: product.name,
              quantity: product.quantity,
              totalPrice: product.totalPrice,
              unitPrice: product.unitPrice
            };

            this.productConfigurations.push(productItem);
          });
        }
      });

      this.saveDuplicatePurchaseQuote();
    }
  }

  saveUpdateQuote() {
    let payload: any = {};
    let canSave: boolean = false;

    if (this.isAdmin && this.selectedQuoteStatus) {
      payload.quote_status = this.selectedQuoteStatus;
      canSave = true;
    }

    if (this.isAdmin && this.selectedQuoteOwner) {
      payload.quote_owner = this.selectedQuoteOwner;
      canSave = true;
    }

    this.store
      .select(updateQuoteSuccess)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((quote) => {
        if (quote) {
          this.toastrService.showSuccessToaster(
            "Success",
            "Quote updated",
            null
          );

          if (this.openModal == 1) {
            this.editCustomerQuoteModal.close();
          }
          if (this.openModal == 2) {
            this.editQuoteModal.close();
          }

          this.openModal = null;
          this._reloadList();
        }
      });

    if (canSave) {
      this.store.dispatch(new UpdateQuote(payload, this.selectedQuote.id));
    }
  }

  retry() {
    this.getQuotes();
  }

  sort(sortableOptions: any) {
    this.currentPage = 1;
    this.searchTerm = "";
    this.filterBy = "";

    this.sortBy = sortableOptions;
    this._reloadList();
  }

  search(searchTerm: string) {
    this.currentPage = 1;
    this.filterBy = "";
    this.sortBy = "";

    this.searchTerm = searchTerm;
    this._reloadList();
  }

  filter(filterBy: object) {
    this.currentPage = 1;
    this.searchTerm = "";
    this.sortBy = "";

    this.filterBy = filterBy;
    this._reloadList();
  }

  paginate(page: string) {
    let pageProps: any = this.paginationService.getPageProps(
      page,
      this.pageCount,
      this.pageLinks
    );

    this.currentPage = pageProps.current === undefined ? 1 : pageProps.current;
    this.pageToLoad = pageProps.pageToLoad === undefined ? 1 : pageProps.pageToLoad;

    this._reloadList();
  }

  private _reloadList() {
    this.store.dispatch(new ClearQuoteList());
    this._loadList();
  }

  _loadList() {
    if (this.isAdmin) {
      this.store.dispatch(
        new GetQuoteList({
          search: this.searchTerm,
          filter: this.filterBy,
          sort: this.sortBy,
          page: this.pageToLoad,
        })
      );
    } else if (this.isCustomer && this.user.customer) {
      this.store.dispatch(
        new GetCustomerQuoteList({
          search: this.searchTerm,
          filter: this.filterBy,
          sort: this.sortBy,
          page: this.pageToLoad,
        })
      );
    } else if (this.isStaff && !this.isAdmin) {
      this.store.dispatch(
        new GetSalesQuoteList({
          search: this.searchTerm,
          filter: this.filterBy,
          sort: this.sortBy,
          page: this.pageToLoad,
        })
      );
    } else {
      this.store.dispatch(
        new GetQuoteList({
          search: this.searchTerm,
          filter: this.filterBy,
          sort: this.sortBy,
          page: this.pageToLoad,
        })
      );
    }
  }

  actionClickEvent(action) {
    switch (action) {
      case "addRental":
        this.addRentalQuote();
        break;
      case "addPurchase":
        this.addPurchaseQuote();
        break;
      default:
        this.addRentalQuote();
    }
  }

  addRentalQuote() {
    const route = AppRoutes.PWA + AppRoutes.NEW_RENTAL_QUOTE;
    this.router.navigate([route]);
  }

  addPurchaseQuote() {
    const route = AppRoutes.PWA + AppRoutes.NEW_PURCHASE_QUOTE;
    this.router.navigate([route]);
  }

  saveDuplicateRentalQuote() {
    const payload: any = {
      quote_status: "new",
      quote_type: "rental",
      quote_validity: this.quote.quoteValidity.id,
      building: this.quote.building.id,
      organization: this.quote.organization.id,
      quote_owner: this.quote.quoteOwner.id,
      customer: this.quote.customer.id,
      your_reference: "Rev01",
      notes: this.quote.notes,
      line_items: [],
      purchase_line_items: [],
      quote_location: this.quote.quoteLocation.id,
      shipping_address1: this.quote.shippingAddress1,
      shipping_address2: this.quote.shippingAddress2,
      shipping_postal: this.quote.shippingPostal,
      shipping_province: this.quote.shippingProvince.id,
      shipping_area: this.quote.shippingArea.id,
      shipping_suburb: this.quote.shippingSuburb,
    };

    this.store
      .select(getCreatedRentalQuote)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((quote) => {
        if (quote) {
          this.createdQuote = quote;
          this.quoteNumber = this.createdQuote.quote_number;

          this.saveLineItems();
        }
      });

    this.store.dispatch(new CreateRentalQuote(payload));
  }

  saveDuplicatePurchaseQuote() {
    const payload: any = {
      quote_status: "new",
      quote_type: "purchase",
      quote_validity: this.quote.quoteValidity ? this.quote.quoteValidity.id : null,
      building: this.quote.building.id,
      organization: this.quote.organization.id,
      quote_owner: this.quote.quoteOwner.id,
      customer: this.quote.customer.id,
      your_reference: "Rev00",
      customer_account_number: this.quote.customerAccountNumber,
      site_allocation: this.quote.siteAllocation,
      notes: this.quote.notes,
      line_items: [],
      purchase_line_items: [],
      quote_location: this.quote.quoteLocation.id,
      required_by: this.quote.requiredBy,
      shipping: this.quote.shipping,
      shipping_address1: this.quote.shippingAddress1,
      shipping_address2: this.quote.shippingAddress2,
      shipping_postal: this.quote.shippingPostal,
      shipping_province: this.quote.shippingProvince ? this.quote.shippingProvince.id : null,
      shipping_area: this.quote.shippingArea ? this.quote.shippingArea.id : null,
      shipping_suburb: this.quote.shippingSuburb,
    };

    this.store
      .select(getCreatedPurchaseQuote)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((quote) => {
        if (quote) {
          this.createdQuote = quote;
          this.quoteNumber = this.createdQuote.quote_number;

          this.savePurchaseLineItems();
        }
      });

    this.store.dispatch(new CreatePurchaseQuote(payload));
  }

  saveLineItems() {
    const item = this.lineItems[0];
    this.saveLineItem(item);

    this.store
      .select(getCreatedLineItems)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((items) => {
        if (items) {
          this.addedLineItems = items;
          if (this.addedLineItems.length == this.lineItems.length) {
            if (this.productConfigurations.length == 0) {
              const route = `${AppRoutes.PWA + "quotes/edit/rental/" + this.createdQuote.id
                }`;
              this.router.navigate([route]);
            } else {
              this.saveProducts();
            }
          } else {
            if (this.addedLineItems.length > 0) {
              const itemToAdd = this.lineItems[this.addedLineItems.length];
              this.saveLineItem(itemToAdd);
            }
          }
        }
      });
  }

  savePurchaseLineItems() {
    const item = this.lineItems[0];
    this.savePurchaseLineItem(item);

    this.store
      .select(getCreatedPurchaseLineItems)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((items) => {
        if (items) {
          this.addedLineItems = items;
          if (this.addedLineItems.length == this.lineItems.length) {
            if (this.productConfigurations.length == 0) {
              const route = `${AppRoutes.PWA + "quotes/edit/purchase/" + this.createdQuote.id
                }`;
              this.router.navigate([route]);
            } else {
              this.savePurchaseProducts();
            }
          } else {
            if (this.addedLineItems.length > 0) {
              const itemToAdd = this.lineItems[this.addedLineItems.length];
              this.savePurchaseLineItem(itemToAdd);
            }
          }
        }
      });
  }

  savePurchaseLineItem(item) {
    let payload = {
      delivery_charge: item.deliveryCharge?.id,
      delivery_charge_extra: item.deliveryChargeExtra?.id,
      delivery_charge_extra_qty: item.deliveryChargeExtraQty ? item.deliveryChargeExtraQty : 0,
      delivery_charge_optional: item.deliveryChargeOptional ? item.deliveryChargeOptional?.id : '',
      delivery_charge_qty: item.deliveryChargeQty ? item.deliveryChargeQty : 0,
      delivery_charge_variation: item.deliveryChargeVariation,
      description: item.description,
      drawing_no: item.drawingNo,
      floor_planner_sku: item.floorPlannerSku,
      name: item.name,
      purchase_asset_item_configurations: [],
      quantity: item.quantity,
      template: item.template,
      thumbnail: item.thumbnail,
      thumbnail_three_d: item.thumbnailThreeD,
      total_price: item.totalPrice,
      unit: item.unit,
      unit_price: item.unitPrice,
      unit_size: item.unitSize,
      quote: this.createdQuote.id,
    };

    this.store.dispatch(new CreatePurchaseLineItem(payload));
  }

  saveLineItem(item) {
    let payload = {
      name: item.name,
      rental_option: item.rental_option,
      rental_period: item.rental_period,
      product_configurations: [],
      delivery_charge: item.delivery_charge,
      quantity: item.quantity,
      quote: this.createdQuote.id,
    };

    this.store.dispatch(new CreateRentalLineItem(payload));
  }

  saveProducts() {
    const addon = this.productConfigurations[0];
    this.saveProduct(addon);

    this.store
      .select(getCreatedProductConfiguration)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((products) => {
        if (products) {
          const productsAdded = products.length;

          if (this.productConfigurations.length == productsAdded) {
            this.duplicateModal.close();
            const route = `${AppRoutes.PWA + "quotes/edit/rental/" + this.createdQuote.id
              }`;
            this.router.navigate([route]);
          } else {
            if (productsAdded > 0) {
              const productToAdd = this.productConfigurations[productsAdded];
              this.saveProduct(productToAdd);
            }
          }
        }
      });
  }
  
  savePurchaseProducts() {
    let addon = this.productConfigurations[0];
    this.savePurchaseProduct(addon);

    this.store
      .select(getCreatedLineItemConfigs)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((products) => {
        if (products) {
          let productsAdded = products.length;

          if (this.productConfigurations.length == productsAdded) {
            const route = `${AppRoutes.PWA + "quotes/edit/purchase/" + this.createdQuote.id
              }`;
            this.router.navigate([route]);
          } else {
            if (productsAdded > 0) {
              let itemIdx = this.productConfigurations[productsAdded];
              this.savePurchaseProduct(itemIdx);
            }
          }
        }
      });
  }

  savePurchaseProduct(addon) {
    let purchase_line_item = this.getLineItemId(addon.name);

    let payload = {
      name: addon.name,
      asset: "",
      quantity: addon.qty,
      unit_price: addon.unitPrice,
      total_price: addon.totalPrice,
      purchase_line_item,
    };

    this.store.dispatch(new CreatePurchaseLineItemConfig(payload));
  }

  saveProduct(addon) {
    const line_item = this.getLineItemId(addon.name);

    let payload = {
      name: this.createdQuote.quote_number + addon.name,
      product: addon.product,
      quantity: addon.quantity,
      line_item,
    };

    this.store.dispatch(new CreateProductConfiguration(payload));
  }

  getLineItemId(productName) {
    let lineItemId = "";
    for (let i = 0; i < this.addedLineItems.length; i++) {
      let lineItemName = this.addedLineItems[i].name;
      let unitName = productName.split(",")[1];
      if (lineItemName == unitName) {
        lineItemId = this.addedLineItems[i].id;
        break;
      }
    }
    return lineItemId;
  }

  ngOnDestroy() {
    this.store.dispatch(new ClearQuoteList());
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
